import request from '../utils/request';

// 推荐展商列表
export function getExLists(data) {
  return request({
    url: '/frontAudience/recommend/exhibitor',
    method: 'post',
    data: data,
  });
}
// 推荐展品列表
export function getProductsLists(data) {
  return request({
    url: '/frontAudience/recommend/exhibit',
    method: 'post',
    data: data,
  });
}

// 直播列表
export function getLiveLists() {
  return request({
    url: '/frontAudience/recommend/live',
    method: 'post',
  });
}

// 活动列表
export function getActivityLists() {
  return request({
    url: '/frontAudience/recommend/activity',
    method: 'post',
  });
}

// 收藏接口
export function collect(data) {
  return request({
    url: '/onlineExhibition/addCollect',
    method: 'get',
    params: data,
  });
}
